import fetchHandler from '../Handler';

export const ProductApprovel = async (endpoint?: any, payload?: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: endpoint,
			data: payload,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
